<template>
  <div class="sidebar__block">
    <h3 :class="{ active: isFilterBlockActive }" class="sidebar__title" @click="toggleFilterBlock">
      {{ filterData.title }}
    </h3>
    <div :class="{ active: isFilterBlockActive }" class="filter">
      <div v-for="option in filterData.options" class="form__group  form__group--sm">
        <div v-if="isCheckbox" class="checkbox  checkbox--sm">
          <input :id="`option_${option.id}`"
                 v-model="selectedOptions"
                 :disabled="isCheckboxDisabled(option)"
                 :value="option.id"
                 class="checkbox__input"
                 type="checkbox"
                 @change="changeFilter"
          >
          <label :for="`option_${option.id}`" class="checkbox__label  checkbox__label--flex">
            <span>{{ option.title }}</span>
            <span class="checkbox__count">{{ option.count }}</span>
          </label>
        </div>

        <div v-else class="checkbox  checkbox--sm">
          <a :href="option.link" :title="option.title" class="option_link">
            <span>{{ option.title }}</span>
            <span class="checkbox__count">{{ option.count }}</span>
          </a>
        </div>
      </div>
    </div><!-- /.filter -->
  </div><!-- /.sidebar__block -->
</template>

<script>
export default {
  props: {
    isLoading:   Boolean,
    filterData:  Object,
    selectedIds: Array,
    filterKey:   String,
    isCheckbox:  {
      type:    Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedOptions:     [...this.selectedIds],
      isFilterBlockActive: true,
    };
  },
  watch:   {
    selectedIds(ids) {
      this.selectedOptions = [...this.selectedIds];
    }
  },
  methods: {
    isCheckboxDisabled(option) {
      return this.isLoading || parseFloat(option.count) === 0;
    },
    changeFilter() {
      this.$emit('changeFilter', this.filterKey, this.selectedOptions);
    },
    toggleFilterBlock() {
      this.isFilterBlockActive = !this.isFilterBlockActive;
    },
  },
};
</script>
